export const loadScript = (url, id) => {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.onload = resolve.bind(id);
        script.src = url;
        script.id = id;
        script.onerror = reject;
        document.head.appendChild(script);
    });
};
//# sourceMappingURL=loadScript.js.map